import type { InputHTMLAttributes } from 'react'
import * as stylex from '@stylexjs/stylex'

import Icon from './Icon'

const styles = stylex.create({
  root: {
    display: 'flex',
    minWidth: 0,
    alignItems: 'center',
    gap: '8px',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#87978a',
    borderRadius: '0.75rem',
    backgroundColor: '#fff',
    paddingInline: '12px',
    transition: 'border-color 150ms, box-shadow 150ms',
    ':hover': { borderColor: '#5f7665' },
    ':focus-within': { borderColor: '#397a4b', boxShadow: '0 0 0 3px rgb(57 122 75 / 20%)' },
  },
  icon: { flexShrink: 0, color: '#6e7c71' },
  input: { minWidth: 0, flex: '1 1 0%', height: '44px', backgroundColor: 'transparent', fontSize: '16px', color: '#27342b', outline: 'none', '::placeholder': { color: '#657268', opacity: 1 } },
})

type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>

export default function SearchInput({ className = '', style, ...props }: SearchInputProps) {
  const rootProps = stylex.props(styles.root)
  return <label className={`${rootProps.className} ${className}`.trim()} style={{ ...rootProps.style, ...style }}><Icon {...stylex.props(styles.icon)} name="search" /><input {...props} {...stylex.props(styles.input)} type="search" /></label>
}
